import type { ContentImportCollection, ContentImportItemDto } from "./types";
import { normalizeLevelImportItem } from "./normalizeLevelImport";
import { normalizeQuestionImportItem } from "./normalizeQuestionImport";

export function normalizeUnitImportItem(
  item: ContentImportItemDto
): ContentImportItemDto {
  return { ...item };
}

export function normalizeStoryImportItem(
  item: ContentImportItemDto
): ContentImportItemDto {
  const next = { ...item };
  if (next.media === undefined) {
    next.media = "";
  }
  if (next.video === undefined) {
    next.video = "";
  }
  return next;
}

export function normalizeImportItem(
  collection: ContentImportCollection,
  item: ContentImportItemDto
): ContentImportItemDto {
  switch (collection) {
    case "units":
      return normalizeUnitImportItem(item);
    case "questions":
      return normalizeQuestionImportItem(item);
    case "stories":
      return normalizeStoryImportItem(item);
    case "levels":
      return normalizeLevelImportItem(item);
  }
}
